import { render, staticRenderFns } from "./OrderInforComp.vue?vue&type=template&id=18f8fb25&scoped=true&"
import script from "./OrderInforComp.vue?vue&type=script&lang=js&"
export * from "./OrderInforComp.vue?vue&type=script&lang=js&"
import style0 from "./OrderInforComp.vue?vue&type=style&index=0&id=18f8fb25&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18f8fb25",
  null
  
)

export default component.exports